import {
  Button,
  HStack,
  IconButton,
  Modal,
  ModalBody,
  ModalContent,
  ModalFooter,
  ModalHeader,
  ModalOverlay,
  Spacer,
  Text,
} from '@chakra-ui/react';

import { ArchiveOutline, CloseCircleOutline } from '@aslanpay/portal-common-lib';

import useArchivePayCalendars from 'app/hooks/useArchivePayCalendars';

import { ArchivePayCalendarModalProps } from './types';

function ArchivePayCalendarModal({
  selectedPayCalendars,
  isOpen,
  onClose,
  onArchive,
}: ArchivePayCalendarModalProps) {
  const isMultiple = selectedPayCalendars.length > 1;
  const title = isMultiple ? 'Archive the selected pay calendars?' : 'Archive pay calendar?';

  const { mutate: archivePayCalendars, isLoading: isArchivingPayCalendar } = useArchivePayCalendars(
    {
      onSuccess: () => {
        onArchive();
        onClose();
      },
      onError: () => {
        onClose();
      },
    }
  );

  return (
    <Modal isOpen={isOpen} onClose={onClose} isCentered>
      <ModalOverlay />
      <ModalContent>
        <ModalHeader>
          <HStack>
            <ArchiveOutline color="brand.purple" boxSize="24px" />
            <Text as="h6">{title}</Text>
            <Spacer />
            <IconButton
              variant="link"
              icon={<CloseCircleOutline boxSize="30px" />}
              aria-label="Close archive pay calendar"
              onClick={onClose}
            />
          </HStack>
        </ModalHeader>
        <ModalBody>
          <Text color="brand.mutedPurple" textStyle="body">
            {`The last deduction report for ${
              isMultiple ? 'each pay calendar' : 'this pay calendar'
            } will still be sent. After that it cannot be edited, and no one can be assigned to it.`}
          </Text>
        </ModalBody>
        <ModalFooter>
          <Spacer />
          <Button variant="outline" size="sm" onClick={onClose}>
            Cancel
          </Button>
          <Button
            size="sm"
            isLoading={isArchivingPayCalendar}
            onClick={() => archivePayCalendars(selectedPayCalendars.map((id) => ({ id })))}
          >
            Yes, archive
          </Button>
        </ModalFooter>
      </ModalContent>
    </Modal>
  );
}

export default ArchivePayCalendarModal;
